import { AlertTriangle } from "lucide-react";

interface SetupWarningProps {
  message: string;
  actionLabel?: string;
  actionHref?: string;
}

export function SetupWarning({ message, actionLabel, actionHref }: SetupWarningProps) {
  return (
    <div className="flex items-center gap-3 p-3 rounded-lg bg-amber-500/10 border border-amber-500/20 text-sm">
      <AlertTriangle className="w-4 h-4 text-amber-500 shrink-0" />
      <span className="text-foreground">{message}</span>
      {actionLabel && actionHref && (
        <a
          href={actionHref}
          className="ml-auto text-amber-600 hover:text-amber-500 font-medium whitespace-nowrap underline underline-offset-2"
        >
          {actionLabel}
        </a>
      )}
    </div>
  );
}
